<template>
  <div
    v-if="open"
    class="modal frequent-work-modal"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
    aria-labelledby="frequent-work-modal-title"
    aria-describedby="frequent-work-modal-description"
    @click.self="close"
    @keydown.esc="close"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div>
            <h2 id="frequent-work-modal-title" class="modal-title fs-5">よく使う作業から選ぶ</h2>
            <p id="frequent-work-modal-description" class="mb-0 mt-1 text-secondary small">
              現在は固定{{ options.length }}件から選択できます。複数の作業をまとめて追加できます。
            </p>
          </div>
          <button type="button" class="btn-close" aria-label="閉じる" @click="close"></button>
        </div>

        <div class="modal-body">
          <div class="frequent-work-list">
            <label
              v-for="(work, index) in options"
              :key="work.id"
              :class="['frequent-work-option', { selected: selectedIds.includes(work.id) }]"
            >
              <input
                :ref="element => setFirstCheckbox(element, index)"
                v-model="selectedIds"
                class="form-check-input"
                type="checkbox"
                :value="work.id"
              >
              <span class="frequent-work-name">{{ work.item_nm }}</span>
              <span class="frequent-work-defaults">
                数量 {{ work.quantity }} ／ 単位 {{ work.unit_nm }}
              </span>
            </label>
          </div>
          <p class="form-text mt-3 mb-0">
            単価・部位・仕様・備考は、追加後に見積書上で入力できます。
          </p>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="close">キャンセル</button>
          <button
            type="button"
            class="btn btn-primary"
            :disabled="selectedIds.length === 0"
            @click="addSelected"
          >
            選択した作業を追加（{{ selectedIds.length }}件）
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { nextTick, ref, watch } from 'vue';

const props = defineProps({
  open: { type: Boolean, default: false },
  options: { type: Array, default: () => [] }
});

const emit = defineEmits(['close', 'select']);
const selectedIds = ref([]);
const firstCheckbox = ref(null);

const setFirstCheckbox = (element, index) => {
  if (index === 0) firstCheckbox.value = element;
};

const close = () => emit('close');
const addSelected = () => {
  const selected = props.options.filter(option => selectedIds.value.includes(option.id));
  if (selected.length === 0) return;
  emit('select', selected);
};

watch(
  () => props.open,
  value => {
    if (!value) return;
    selectedIds.value = [];
    nextTick(() => firstCheckbox.value?.focus());
  }
);
</script>

<style scoped>
.frequent-work-modal {
  display: block;
  overflow-y: auto;
  background: rgba(0, 0, 0, 0.5);
}

.frequent-work-list {
  display: grid;
  gap: 10px;
}

.frequent-work-option {
  display: grid;
  padding: 14px 16px;
  border: 1px solid #c8d2da;
  border-radius: 6px;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  background: #fff;
}

.frequent-work-option:hover,
.frequent-work-option.selected {
  border-color: #5d85a1;
  background: #f0f7fb;
}

.frequent-work-name {
  font-weight: 700;
}

.frequent-work-defaults {
  color: #526672;
  font-size: 0.85rem;
  white-space: nowrap;
}

@media (max-width: 576px) {
  .frequent-work-option {
    grid-template-columns: auto minmax(0, 1fr);
  }

  .frequent-work-defaults {
    grid-column: 2;
    white-space: normal;
  }
}
</style>
